import { createContext, useReducer } from 'react'
import { type InventoryProviderProps, type InventoryDataContextProps, type InventoryDispatchContextProps } from 'src/types'

import { reducer } from './reducer'
import { defaultInventory } from './defaults'

export const InventoryDataContext = createContext<InventoryDataContextProps>({ inventory: defaultInventory })
InventoryDataContext.displayName = 'InventoryDataContext'

export const InventoryDispatchContext = createContext<InventoryDispatchContextProps>({ dispatchInventory: () => null })
InventoryDispatchContext.displayName = 'InventoryDispatchContext'

export const InventoryProvider = ({ children }: InventoryProviderProps) => {
  const [inventory, dispatchInventory] = useReducer(reducer, defaultInventory)
  
  return (
    <InventoryDataContext.Provider value={{ inventory }}>
      <InventoryDispatchContext.Provider value={{ dispatchInventory }}>
        {children}
      </InventoryDispatchContext.Provider>
    </InventoryDataContext.Provider>
  )
}
